





































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import userInterface from '../interface/user';
import ModalWindow from '../ModalWindow/ModalWindow.vue';
import Prepare from '../Game/Prepare.vue';
import playSound from '../../utils/sounds/index';
import taskInterface from '../interface/taskInterface';

@Component({
  computed: {
    ...mapGetters([
      'getUsers',
      'getTurn',
      'getRouteDeck',
      'getCardDeck',
      'getCardTable',
      'getCurrentName',
      'getTurnWeight',
    ]),
  },
  components: {
    ModalWindow,
    Prepare,
  },
})
export default class DeckSide extends Vue {
  getCardTable!: string[];

  getRouteDeck!: number[];

  getCardDeck!: number[];

  getTurn!: number;

  getTurnWeight!: number;

  getUsers!: userInterface[];

  getCurrentName!: string;

  showRoutesModal = false;

  modalTimer = 180;

  routesToChoose: number[] = [];

  timerForWait = 200;

  userReady = true;

  setTimerForUser(): void {
    this.userReady = false;
    setTimeout(() => {
      this.userReady = true;
    }, this.timerForWait);
  }

  get checkActive(): boolean {
    if (this.getTurn === -1) return false;
    return (
      this.getUsers[this.getTurn % this.getUsers.length].name === this.getCurrentName
      && this.userReady
    );
  }

  pickRoute(): void {
    playSound('takeRouteCards');
    if (this.getRouteDeck.length > 0) {
      this.routesToChoose.push(...this.getRouteDeck.splice(-3));
      this.showRoutesModal = true;
    }
    // TODO: socket emit split routes deck
    // TODO: routes to choose ->> shortRoutes in hand (in Prepare)
  }

  discardRoute(array: taskInterface[]): void {
    this.routesToChoose.splice(0);
    array.forEach((route) => {
      this.$socket.emit('discardRoute', this.getCurrentName, route);
    });
    this.setTimerForUser();
    setTimeout(() => {
      this.$socket.emit('endOfTurn');
    }, this.timerForWait);
  }

  pickCardTable(cardNumber: number): void {
    const color = this.getCardTable[cardNumber];
    if ((color === 'loco' && this.getTurnWeight === 0) || color !== 'loco') {
      this.$socket.emit('pickCardTable', this.getCurrentName, cardNumber, color);
      playSound('takeCard');
      this.setTimerForUser();
      if (color === 'loco' || this.getTurnWeight > 0) {
        this.$socket.emit('endOfTurn');
      }
    }
  }

  pickCardDeck(): void {
    playSound('takeCard');
    this.$socket.emit('pickCardDeck', this.getCurrentName);
    this.setTimerForUser();
    if (this.getTurnWeight > 0) {
      this.$socket.emit('endOfTurn');
    }
  }

  enableKeyboardControls(): void {
    document.addEventListener('keydown', (e) => {
      if (this.checkActive) {
        if (e.code.startsWith('Digit')) {
          const cardNum = +e.code.slice(-1);
          if (cardNum <= this.getCardTable.length) {
            this.pickCardTable(cardNum - 1);
          }
        }
        if (e.code === 'KeyW') this.pickCardDeck();
        if (e.code === 'KeyR') this.pickRoute();
      }
    });
  }

  showCities(cities: string[]): void {
    this.$emit('showCities', cities);
  }

  hideCities(): void {
    this.$emit('hideCities');
  }

  created(): void {
    this.enableKeyboardControls();
  }
}
